var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSmileySad = function SvgIconSmileySad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 10.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.375 11.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 13.251a5.5 5.5 0 0 0-4.274 2.038 1 1 0 0 0 1.554 1.26 3.5 3.5 0 0 1 5.44 0 1 1 0 1 0 1.554-1.26A5.5 5.5 0 0 0 12 13.251"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconSmileySad;